import type { Action } from 'react-sweet-state';

import { FIELD_STATE_IDLE } from '../constants';
import type { InlineFieldData, InlineFieldsState } from '../types';

export const setFieldState =
	(data: InlineFieldData): Action<InlineFieldsState> =>
	({ setState, getState }) => {
		const currentState = getState();
		const stateObject = {
			status: data.status ?? currentState[data.fieldId]?.status,
			onFormSubmit: data.onFormSubmit ?? currentState[data.fieldId]?.onFormSubmit,
		};
		setState({ ...getState(), [data.fieldId]: stateObject });
	};

export const resetState =
	(): Action<InlineFieldsState> =>
	({ getState, setState }) => {
		const stateToOverride: Record<string, { status: typeof FIELD_STATE_IDLE }> = {};
		Object.getOwnPropertyNames(getState()).forEach((fieldId) => {
			stateToOverride[fieldId] = { status: FIELD_STATE_IDLE };
		});
		setState(stateToOverride);
	};
